import { useRef, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Tooltip } from 'antd';
import { CoreBadge } from '../../../RnRCommonComponent';
import {
	CheckOutlined,
	LeftCircleFilled,
	RightCircleFilled,
} from '@ant-design/icons';
import {
	addCommas,
	getBadgeCategoryLabel,
} from '../../../rewardsAndRecognitionHelper/utils.js';

function CustomNextArrow(props) {
	const { className, style, onClick } = props;
	return (
		<RightCircleFilled
			onClick={onClick}
			className={className}
			style={{ ...style }}
		/>
	);
}

function CustomPrevArrow(props) {
	const { className, style, onClick } = props;
	return (
		<LeftCircleFilled
			onClick={onClick}
			className={className}
			style={{ ...style }}
		/>
	);
}

export const SendRewardSlider = (props) => {
	const {
		badgeData,
		currentUser,
		setSendRewardObject,
		sendRewardObject,
		selectedPage,
	} = props;
	let sliderRef = useRef(null);
	const requireAdminApproval =
		currentUser?.company?.recognitionSettings?.requireAdminApproval ?? false;

	useEffect(() => {
		sliderRef.slickGoTo(selectedPage);
	}, [selectedPage]);

	const settings = {
		dots: true,
		infinite: badgeData?.length >= 3,
		speed: 500,
		slidesToShow: badgeData?.length >= 3 ? 3 : badgeData?.length,
		slidesToScroll: badgeData?.length >= 3 ? 3 : 0,
		nextArrow: <CustomNextArrow />,
		prevArrow: <CustomPrevArrow />,
	};

	const handleClick = (badge) => {
		setSendRewardObject({
			...sendRewardObject,
			rewardtype: badge.id,
			selectedBadge: badge,
		});
	};

	return (
		<div className="main-slider-container">
			<Slider
				ref={(slider) => {
					sliderRef = slider;
				}}
				{...settings}
				className="badge-slider"
			>
				{badgeData?.map((badge) => {
					const hasSnappyId = badge?.snappyGrantId || badge?.snappyGrant?.id;
					const isManagerOrAdmin = ['manager', 'admin', 'superadmin'].includes(
						currentUser?.role?.toLowerCase()
					);
					const hideSnappyIcon = !(hasSnappyId && isManagerOrAdmin);
					const currencySymbol = badge?.snappyGrant?.currencySymbol || '$';

					const snappyDetails = hasSnappyId
						? {
								snappyGrantId: badge?.snappyGrantId || badge?.snappyGrant?.id,
								snappyGrantName: badge?.snappyGrant?.name || 'Snappy Reward',
								costInCurrency: `${currencySymbol}${badge?.snappyGrant?.costInCurrency || '0'}`,
								description:
									badge?.snappyGrant?.description || 'Snappy Gift Attached ⭐️',
							}
						: {};

					return (
						<div
							key={'badge-' + badge.id}
							className={`${sendRewardObject?.rewardtype === badge.id ? 'send-reward-slider' : 'slider-container-hover'} slider-container`}
						>
							<div
								className="slider-img"
								disabled={badge.visibility === false}
								style={{
									cursor: 'pointer',
									opacity: badge.visibility === false ? 0.3 : 1,
								}}
							>
								{sendRewardObject?.rewardtype === badge.id ? (
									<div className="active-tick send-reward-slider">
										{/* <Icon type="check" /> */}
										<CheckOutlined />
									</div>
								) : (
									<></>
								)}
								<Tooltip
									placement="top"
									title={badge?.description}
									align={{ offset: [0, -10] }}
									style={{ fontWeight: 900 }}
								>
									<div style={{ textAlign: 'center' }}>
										<div
											onClick={() => handleClick(badge)}
											className="slider-badges-svg"
										>
											{' '}
											{/* Pass the badge object to handleClick */}
											<CoreBadge
												badgeType={badge?.badgeTypeCode}
												badgeIcon={badge?.iconCode}
												label={badge?.label}
												color={badge?.color}
												gradientColor={badge?.gradientColor}
												shape={badge?.shape}
												badgeRotation={badge?.badgeRotation}
												customImageSignedUrl={badge?.customImageSignedUrl}
												labelColor={badge?.labelColor}
												customIconSignedUrl={badge?.customIconSignedUrl}
												hideSnappyIcon={hideSnappyIcon}
												snappyDetails={snappyDetails}
											/>
										</div>
										{badge?.points > 0 ? (
											<div className="text-center img-label">
												<div
													style={{
														padding: '0 4px',
														fontSize: '14px',
														fontWeight: 900,
														marginTop: '10px',
														color: 'rgba(0, 0, 0, 0.85)',
													}}
													className="text-center"
												>
													{badge?.name}
												</div>
												<span style={{ color: '#1d8627', fontWeight: 700 }}>
													{addCommas(badge.points) + ' Points' || ''}
												</span>
											</div>
										) : (
											(
												<div
													style={{
														padding: '0 4px',
														fontSize: '14px',
														fontWeight: 'bold',
														marginTop: '10px',
														color: 'rgba(0, 0, 0, 0.85)',
													}}
													className="text-center"
												>
													{badge?.name}
												</div>
											) || ''
										)}
										{getBadgeCategoryLabel(badge) ? (
											<span className="badge-category-pill">
												{getBadgeCategoryLabel(badge)}
											</span>
										) : null}
										{badge?.isPreApproved && !requireAdminApproval ? null : (
											<span
												style={{
													color: 'var(--old-mandarin)',
													fontWeight: 900,
													fontSize: '10px',
													lineHeight: 'normal',
													display: 'block',
												}}
											>
												Approval Required
											</span>
										)}
									</div>
								</Tooltip>
							</div>
						</div>
					);
				})}
			</Slider>
		</div>
	);
};
export default SendRewardSlider;
